import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 22 22"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M18.51 7.987a.69.69 0 0 0-.635-.425H4.125a.687.687 0 0 0-.486 1.174l6.875 6.875a.687.687 0 0 0 .972 0l6.875-6.875a.69.69 0 0 0 .15-.75"
    }, null, -1)
  ])))
}
export default { render: render }